var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.asyncDept)?_c('sync-dept-tree',_vm._g(_vm._b({},'sync-dept-tree',_vm.$attrs,false),_vm.$listeners)):_c('async-dept-tree',_vm._g(_vm._b({},'async-dept-tree',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }